import type { ComponentSchema, FieldSchema } from '../../../../../schema-types'
import { MEGA_MENU_SCHEMA } from '../../_builder-constants'
import { schema as baseHeader } from '../header/header.schema'

/** Menu items: the stored link / dropdown / mega-menu types plus the Shop panel and a small badge. */
const MENU_ITEM_SCHEMA: FieldSchema[] = [
  ...MEGA_MENU_SCHEMA.map(field => (field.key === 'type'
    ? { ...field, options: [...(field.options ?? []), { label: 'Shop panel (category tiles)', value: 'categories' }] }
    : field)),
  { key: 'badge', label: 'Badge', type: 'string', placeholder: 'New', help: 'Small label next to the item.' },
]

/** Announcement ticker fields read by the Neon Cinema header, added to the stored top bar. */
const TICKER_FIELDS: FieldSchema[] = [
  {
    key: 'messages',
    label: 'Ticker messages',
    type: 'array',
    help: 'Run across the top bar; the single announcement text is used when this is empty.',
    itemSchema: [
      { key: 'text', label: 'Text', type: 'localized-string' },
      { key: 'link', label: 'Link', type: 'string' },
    ],
  },
  { key: 'dismissible', label: 'Shoppers can close it', type: 'boolean', default: false },
]

/** Neon Cinema header: the base header (stored keys unchanged) plus ticker messages, search placeholder, menu badges and the Shop panel. */
export const schema: ComponentSchema = {
  ...baseHeader,
  commonFields: [
    ...(baseHeader.commonFields ?? []).map((field) => {
      if (field.key === 'topbar') return { ...field, fields: [...(field.fields ?? []), ...TICKER_FIELDS] }
      if (field.key === 'menu') return { ...field, itemSchema: MENU_ITEM_SCHEMA }
      return field
    }),
    { key: 'searchPlaceholder', label: 'Search placeholder', type: 'string', placeholder: 'Search products…' },
  ],
}
